import { AppThunk } from "../../thunks";
import { AccountLoginState, CreateAccountRequest, AccountRegisterState, AccountRecoverPasswordState, address, QuestionsRequestVA } from "./types";
import {
    postAccountLoginAPI, postAccountLoginUserAPI,
    postCreateAccountAPI, postRecoverAccountAPI, postUpdateAccountAPI,putUnsubscribedAPI, postValidateTokenPasswordResetAPI,
    postPasswordResetAPI 
} from "../../services/restcall";
import { toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { setMessageResponse } from "../system/actions";
import { loginCookie} from "../../components/User/Auth";
import moment from 'moment';

export const postAccountLogin = (accountLoginState: AccountLoginState): AppThunk => async (dispatch, getSate) => {
    await postAccountLoginAPI(accountLoginState);
};
export const postAccountLoginUser = (accountLoginState: AccountLoginState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postAccountLoginUserAPI(accountLoginState);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error.error;
        let message: MessageResponse;
        if (responseData.Error.error.length >= 500 && errorResponse !== "") {
            message = {
                code: responseData.Error.status,
                message: ["Existe un error por favor comuniquese: juan.vallejo@ixion.com.ec"]
            };
        }
        else {
            message = {
                code: responseData.Error.status,
                message: ["Usuario o contraseña incorrecta. Revisar por favor​"]
            };
        }
        dispatch(setMessageResponse(message))
    }
    else {
        if (responseData.StatusCode === 200) {
            loginCookie(responseData.Response.access_token);
            window.location.replace(process.env.REACT_APP_BASE_URL_ADMIN as string);
        }
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postQuestionsVA = (accountRegisterState: AccountRegisterState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const requestAddressVA: address = {
        city: accountRegisterState.cityAnother,
        main_street: accountRegisterState.primaryRoadUser,
        secondary_street: accountRegisterState.secondaryRoadUser,
        residence_number: accountRegisterState.houseNumberUser
    }
    const requestQuestionVASales: QuestionsRequestVA = {
        id: accountRegisterState.id,
        type_beneficiary: accountRegisterState.type_beneficiary,
        type_identification: accountRegisterState.typeIdentificationAnother,
        identification: accountRegisterState.identificationAnother,
        firstname: accountRegisterState.firstNameAnother,
        slug_product: accountRegisterState.slug_product,
        lastname: accountRegisterState.lastNameAnother,
        birthdate: moment(accountRegisterState.birthdateAnotherDate === null ? '1900-01-01' : accountRegisterState.birthdateAnotherDate).format("YYYY-MM-DD"),
        gender: accountRegisterState.genderAnother,
        phone: accountRegisterState.phoneAnother,
        email: accountRegisterState.emailAnother,
        id_plandetailproduct: accountRegisterState.id_plandetailproduct,
        step: accountRegisterState.step,
        country_code: accountRegisterState.country_code,
        address: requestAddressVA,
        beneficiary: null,
        status: accountRegisterState.status
    }
}

export const postCreateAccount = (accountRegisterState: AccountRegisterState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));

    const createAccountRequest: CreateAccountRequest = {
        firstName: accountRegisterState.firstNameAnother,
        lastName: accountRegisterState.lastNameAnother,
        email: accountRegisterState.emailAnother,
        identification: accountRegisterState.identificationAnother,
        type: accountRegisterState.typeIdentificationAnother,
        gender: accountRegisterState.genderAnother,
        password: accountRegisterState.password,
        phone: accountRegisterState.phoneAnother,
        civilstatus: accountRegisterState.civilstatus,
        country: accountRegisterState.countryAnother,
        city: accountRegisterState.cityAnother,
        birthday: moment(accountRegisterState.birthdateAnotherDate === null ? '1900-01-01' : accountRegisterState.birthdateAnotherDate).format("YYYY-MM-DD"),
        accept_terms_conditions: accountRegisterState.acceptTerms ? 'true' : 'false',
        slug: accountRegisterState.slug
    };

    const responseData = await postCreateAccountAPI(createAccountRequest);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error.error;
        if (responseData.Error.status >= 400 && errorResponse !== "") {
            const serverMessage = JSON.parse(responseData.Error.message);
            const message: MessageResponse = {
                code: responseData.Error.status,
                message: serverMessage.errors?.error
            };
            dispatch(setMessageResponse(message));
        }
    }
    else {
        if (responseData.StatusCode === 200) {
            const accountLoginState: AccountLoginState = {
                username: accountRegisterState.emailAnother,
                password: accountRegisterState.password
            }
            const responseData = await postAccountLoginUserAPI(accountLoginState);
            if (responseData.StatusCode === 200) {          

                if(createAccountRequest.slug === "FREE") {
                    loginCookie(responseData.Response.access_token);
                    window.location.replace(process.env.REACT_APP_BASE_URL_ADMIN as string);
                }

                if(createAccountRequest.slug === "PLANINDIVIDUAL" || createAccountRequest.slug === "PLANFAMILIAR" || createAccountRequest.slug === "PLANMASSESENTA") {
                    window.location.replace(
                        (process.env.REACT_APP_BASE_URL as string) + "/user?email="+createAccountRequest.email
                        );
                }
            }
        }
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};
export const postRecoverAccount = (accountRecoverPassword: AccountRecoverPasswordState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await postRecoverAccountAPI(accountRecoverPassword);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error.error;
        if (responseData.Error.status >= 400 && errorResponse !== "") {
            const serverMessage = JSON.parse(responseData.Error.message);
            const message: MessageResponse = {
                code: responseData.Error.status,
                message: serverMessage.errors?.error
            };
            dispatch(setMessageResponse(message));
        }
    }
    else {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};
export const postUpdateAccount = (accountUpdatePassword: AccountRecoverPasswordState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await postUpdateAccountAPI(accountUpdatePassword);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error.error;
        if (responseData.Error.status >= 400 && errorResponse !== "") {
            const serverMessage = JSON.parse(responseData.Error.message);
            const message: MessageResponse = {
                code: responseData.Error.status,
                message: serverMessage.errors?.error
            };
            dispatch(setMessageResponse(message));
        }
    }
    else {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};

export const putUnsubscribed = (token: string): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await putUnsubscribedAPI(token);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message: MessageResponse = {
                code: errorResponse.status,
                message: [errorResponse.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};

export const validateTokenResetPassword = (account: AccountRecoverPasswordState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await postValidateTokenPasswordResetAPI(account);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error.error;
        if (responseData.Error.status >= 400 && errorResponse !== "") {
            const serverMessage = JSON.parse(responseData.Error.message);
            const message: MessageResponse = {
                code: responseData.Error.status,
                message: serverMessage.errors?.error
            };
            dispatch(setMessageResponse(message));
        };
    }
    else {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};
export const postPasswordReset = (accountRecoverPassword: AccountRecoverPasswordState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await postPasswordResetAPI(accountRecoverPassword);
    if (responseData.Error !== null) {
        const errorResponse = responseData.Error.error;
        if (responseData.Error.status >= 400 && errorResponse !== "") {
            const serverMessage = JSON.parse(responseData.Error.message);
            const message: MessageResponse = {
                code: responseData.Error.status,
                message: serverMessage.errors?.error
            };
            dispatch(setMessageResponse(message))
        }
    }
    else {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};